import { render, staticRenderFns } from "./D_RitualGold.vue?vue&type=template&id=b778f1f4&scoped=true&"
import script from "./D_RitualGold.vue?vue&type=script&lang=js&"
export * from "./D_RitualGold.vue?vue&type=script&lang=js&"
import style0 from "./D_RitualGold.vue?vue&type=style&index=0&id=b778f1f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b778f1f4",
  null
  
)

export default component.exports